export default __webpack_public_path__ + "static/media/Blog1_2.ecdbe013.jpg";